import { getFunctions, httpsCallable, connectFunctionsEmulator } from "firebase/functions";

const functions = getFunctions();
if (process.env.NODE_ENV === "development") connectFunctionsEmulator(functions, "127.0.0.1", 5001);

// Auth
export const triggerRoomLogin = httpsCallable(functions, "triggerRoomLogin");

// JL AI
export const createJLAI = httpsCallable(functions, "createJLAI", { timeout: 540000 });
export const addToMailchimp = httpsCallable(functions, "addToMailchimp");

export const generateNumerologyPdf = httpsCallable(functions, "generateNumerologyPdf", { timeout: 540000 });
export const generateNumerologyMandala = httpsCallable(functions, "generateNumerologyMandala", { timeout: 540000 });

export const initiateStripeCheckout = httpsCallable(functions, "initiateStripeCheckout");

export const sendEmail = httpsCallable(functions, "sendEmail");
